import { useEffect } from "react";
import { Toast } from "./index";

export const ToastWrapper = ({
  id,
  text,
  severity,
  index,
  onClose,
}: {
  id: number;
  text: string;
  severity: "success" | "error" | "info" | "warning";
  index: number;
  onClose: (id: number) => void;
}) => {
  const spacing = -10;
  const height = 64;
  const baseBottom = 16;
  const duration = 2500; // auto-close ms

  // Auto-close timer
  useEffect(() => {
    const timer = setTimeout(() => onClose(id), duration);
    return () => clearTimeout(timer);
  }, [id, onClose]);

  return (
    <Toast
      message={text}
      severity={severity}
      onClose={() => onClose(id)}
      style={{
        bottom: baseBottom + index * (height + spacing),
      }}
    />
  );
};
